import { blogDetailConstant } from "../_constants/blogDetail.constant";
import { alert } from "../_utilities/alert";
import { blogDetailService } from "../_services/blogDetail.service";
import { configes } from "../webData";

export const blogAction = {
  getBlogDetail,
  getBlogSlug
};


function getBlogDetail() {
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: blogDetailConstant.GET_BLOG_DETAIL_REQUEST,
        data: null,
      })
    );
    blogDetailService
    .getBlogDetail()
    .then(
      (response) => {
        if (response.Status === 200) {
            console.log(9, response);
            dispatch(
              dispatchFunction({
                type: blogDetailConstant.GET_BLOG_DETAIL_SUCCESS,
                data: response.Result.blog,
              })
            );
          } else {
            dispatch(
              dispatchFunction({
                type: blogDetailConstant.GET_BLOG_DETAIL_FAILURE,
                data: null,
              })
            );
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: blogDetailConstant.GET_BLOG_DETAIL_FAILURE,
              data: error,
            })
          );
        }
      )
      .catch((error) => {
        alert.error("Oops! Something went wrong!");
      });
  };
}



function getBlogSlug(data) {
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: blogDetailConstant.GET_BLOGSLUG_DETAIL_REQUEST,
        data: null,
      })
    );
    console.log("294 data", data);
    console.log("295", { ...data, tenantId: configes.domainId});

    blogDetailService
      .getBlogBySlug(data)
      .then(
        (response) => {
          if (response.Status === 200) {
            dispatch(
              dispatchFunction({
                type: blogDetailConstant.GET_BLOGSLUG_DETAIL_SUCCESS,
                data: response.Result.blog,
              })
            );
          } else {
            dispatch(
              dispatchFunction({
                type: blogDetailConstant.GET_BLOGSLUG_DETAIL_FAILURE,
                data: null,
              })
            );
            alert.error(response.Message);
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: blogDetailConstant.GET_BLOGSLUG_DETAIL_FAILURE,
              data: error,
            })
          );
          alert.error("Oops! Something went wrong!!");
        }
      )
      .catch(() => {
        alert.error("Oops! Something went wrong!!");
      });
  };
}

function dispatchFunction(data) {
  return {
    type: data.type,
    data: data.data,
  };
}
